import { useTranslation } from 'react-i18next';
import { GENDER_OPTIONS } from '@anytag/shared-constants';
import { useTranslateOptions } from '@anytag/shared-hooks';
import { MultipleSelectorFieldProps, SelectorField } from '@anytag/shared-molecules';
import { InfluencersFilterFormKeys } from '../schemaTypes';

export const GenderField = (
  props: Omit<MultipleSelectorFieldProps<InfluencersFilterFormKeys>, 'name' | 'options' | 'multiple'>
) => {
  const { t } = useTranslation();
  const genderOptions = useTranslateOptions(GENDER_OPTIONS);

  return (
    <SelectorField<InfluencersFilterFormKeys>
      name="genders"
      options={genderOptions}
      placeholder={t<string>('Selector.Gender')}
      multiple
      {...props}
    />
  );
};
